(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-region"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionEl = document.getElementById('shopify-section-{{ section.id }}');
  if (!sectionEl) return;

  var track   = sectionEl.querySelector('.sbc-track');
  var prevBtn = sectionEl.querySelector('.sbc-arrow--prev');
  var nextBtn = sectionEl.querySelector('.sbc-arrow--next');
  var dotWrap = sectionEl.querySelector('.sbc-dots');
  var cards   = track.querySelectorAll('.sbc-card');

  // card width (264) + gap (16)
  var CARD_STEP = 280;

  /* ── Arrow scroll ── */
  prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -(CARD_STEP * 2), behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function () {
    track.scrollBy({ left: CARD_STEP * 2, behavior: 'smooth' });
  });

  /* ── Build dot indicators ── */
  var totalDots = Math.ceil(cards.length / 3);
  var dots = [];

  for (var i = 0; i < totalDots; i++) {
    var btn = document.createElement('button');
    btn.className = 'sbc-dot' + (i === 0 ? ' is-active' : '');
    btn.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
    (function (idx) {
      btn.addEventListener('click', function () {
        track.scrollTo({ left: idx * CARD_STEP * 3, behavior: 'smooth' });
      });
    })(i);
    dotWrap.appendChild(btn);
    dots.push(btn);
  }

  /* ── Sync dots on scroll ── */
  track.addEventListener('scroll', function () {
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 0) return;
    var active = Math.round((track.scrollLeft / max) * (dots.length - 1));
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === active);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
